import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <a
        href="https://www.linkedin.com/in/rein-brobbel-9709741a2/"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={require("./Assets/linkedin-logo.png")}
          alt="LinkedIn"
          className="linkedin"
        />
      </a>
      <a href="mailto:r.brobbel@qquest.nl">
        <img
          src={require("./Assets/email-logo.png")}
          alt="Email"
          className="email"
        />
      </a>
    </div>
  );
};

export default Footer;
